import React from "react";
import { Image, Spinner } from "react-bootstrap";

const Performer = ({ user, isLoading }) => {
  return (
    <div className="d-flex align-items-center justify-content-between mb-2 text-light">
      {isLoading ? (
        <Spinner size="sm" />
      ) : (
        <>
          <div className="d-flex align-items-center">
            <Image src="/man.png" alt="Man" height={30} />
            <b className="ms-3">
              {user?.first_name} {user?.last_name}
            </b>
          </div>
          <p className="mb-0">{user?.referral_code}</p>
        </>
      )}
    </div>
  );
};

export default Performer;